<rt-visibility-selector
  [dropdownPositions]="dropdownPositions"
  [dropdownOffsetX]="dropdownOffsetX"
  [dropdownOffsetY]="dropdownOffsetY"
  [visibility]="visibility"
  [admins]="admins"
  [wrapOnSmallerResolutions]="wrapOnSmallerResolutions"
  [hasLabel]="hasLabel"
  [editable]="editable"
  [avatarMaxLength]="avatarMaxLength"
  [hasOnlyMeLevel]="hasOnlyMeLevel"
  [hasSelectTeamMembers]="hasSelectTeamMembers"
  [rolesWithAdmins]="rolesWithAdmins"
  [allowAdminsChange]="allowAdminsChange"
  [infoContext]="infoContext"
  [buttonVariant]="buttonVariant"
  [protectedUsersPosition]="protectedUsersPosition"
  [labels]="labels"
  [avatarSize]="avatarSize"
  (visibilityChanges)="onVisibilityChanges($event)"
  (visibilityDropdownToggle)="onVisibilityDropdownToggle($event)"
  layout-align-items-center
></rt-visibility-selector>
